import { QuotaTypes } from './SubscriptionInterface'
import { BillingCycleOption, SubscriptionPlanInterface } from './SubscriptionPlanInterface'

export enum SubscriptionFeatureCheckboxType {
  GREEN,
  ELECTRIC_GREEN,
  DEEP_SEA_GREEN,
  DISABLED,
  RED,
  DASH,
}

export enum SubscriptionFeatureType {
  INVOICING = 'invoicing',
  ACCOUNTING = 'accounting',
  ADMIN = 'admin',
}

export interface ISubscriptionFeatureItem {
  id?: QuotaTypes
  type?: SubscriptionFeatureType
  checkboxStyle?: SubscriptionFeatureCheckboxType
  amount?: number // if less than zero will draw an INFINITY icon
  translationKeyMonth?: string
  translationKeyYear?: string
}
export interface ISubscriptionFeatureList {
  className?: string
  selectedPlanName?: string
  drawSeparationLine?: boolean
  highlights?: ISubscriptionFeatureItem[]
  items?: ISubscriptionFeatureItem[]
  billingCycle?: BillingCycleOption
}
